export default __webpack_public_path__ + "static/media/add_manually.225017bd.png";